import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { OrdenacaoTabela } from '../../utils/ordenacao-tabela';

/**
 * Cabeçalho de tabela clicável para ordenação.
 *
 *   <th appThOrdenavel="contactName" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">
 *     NOME
 *   </th>
 */
@Component({
  selector: 'th[appThOrdenavel]',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './th-ordenavel.component.html',
  styleUrl: './th-ordenavel.component.scss',
})
export class ThOrdenavelComponent {
  @Input('appThOrdenavel') coluna = '';
  @Input() ordenacao: OrdenacaoTabela | null = null;

  @Output() ordenar = new EventEmitter<string>();

  /** Sem coluna a ordenação fica desligada — útil em cabeçalhos gerados por *ngFor. */
  @HostBinding('class.th-ordenavel')
  get habilitado(): boolean {
    return !!this.coluna;
  }

  @HostBinding('attr.role')
  get role(): string | null {
    return this.habilitado ? 'button' : null;
  }

  @HostBinding('attr.aria-sort')
  get ariaSort(): string | null {
    if (!this.habilitado) return null;
    if (!this.ativa) return 'none';
    return this.ordenacao?.direcao === 'asc' ? 'ascending' : 'descending';
  }

  @HostListener('click')
  onClick(): void {
    if (!this.habilitado) return;
    this.ordenar.emit(this.coluna);
  }

  get ativa(): boolean {
    return this.habilitado && this.ordenacao?.coluna === this.coluna;
  }

  get icone(): string {
    if (!this.ativa) return 'unfold_more';
    return this.ordenacao?.direcao === 'asc' ? 'arrow_upward' : 'arrow_downward';
  }
}
